var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-768 -952)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.119,195.722h0a3.767,3.767,0,0,0-3.166,1.019l-.172.165-3.335-1.949.06-.23a4.273,4.273,0,0,0,0-2.063l-.059-.229,3.335-1.953.17.168a3.84,3.84,0,1,0,5.395-5.466,3.982,3.982,0,0,0-2.722-1.107,3.841,3.841,0,0,0-3.815,3.834,3.611,3.611,0,0,0,.033.508l.029.208-3.469,2.016-.17-.158a4.36,4.36,0,1,0-2.972,7.554,4.2,4.2,0,0,0,2.97-1.163l.172-.161,3.468,2.043-.027.2a3.756,3.756,0,0,0,3.171,4.188,3.652,3.652,0,0,0,.563.042,3.754,3.754,0,0,0,3.748-3.761A3.777,3.777,0,0,0,191.119,195.722Zm-.577-9.574a1.784,1.784,0,1,1-1.784,1.784A1.784,1.784,0,0,1,190.542,186.148Zm-10.264,9.834h-.014a2.466,2.466,0,0,1-1.627-.671,2.3,2.3,0,0,1,1.622-3.929h.009a2.3,2.3,0,0,1,.01,4.6Zm10.291,5.145a1.693,1.693,0,1,1,1.692-1.694A1.694,1.694,0,0,1,190.569,201.127Z",
    transform: "translate(598.094 772.922)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    transform: "translate(768 952)",
    fill: "#fff",
    opacity: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.f0c19ee16fe3a797c990240afe4a3eda.svg";
export { ForwardRef as ReactComponent };